/* eslint-disable prettier/prettier */
/* This file is automatically generated by the plugin 'request-plugin'. Please do not modify. */

import axios from 'axios';

export const instances = {
  DEFAULT: axios.create({ baseURL: 'https://dev-halo-api.noim.uk' }),
  AUTH: axios.create({ baseURL: 'https://dev-oauth-server.noim.uk' }),
FILE: axios.create({ baseURL: 'https://dev-xtransfer.noim.uk' }),
WS: axios.create({ baseURL: 'wss://dev-halo-api.noim.uk' }),
}

export default Object.assign(instances.DEFAULT, instances);